import { Route } from 'vue-router';

import DapProjectEmptyPage from '@/modules/dap/pages/dap-project-empty/dap-project-empty.page.vue';
import DapProjectPage from '@/modules/dap/pages/dap-project/dap-project.page.vue';
import DapProjectsPage from '@/modules/dap/pages/dap-projects/dap-projects.page.vue';
import DapSubmittedProjectPage from '@/modules/dap/pages/dap-submitted-project/dap-submitted-project.page.vue';
import DapSubmittedProjectRetailPage from '@/modules/dap/pages/dap-submitted-project-retail/dap-submitted-project-retail.page.vue';
import DapSubmittedProjectsPage from '@/modules/dap/pages/dap-submitted-projects/dap-submitted-projects.page.vue';
import DapWizardCreatePage from '@/modules/dap/pages/dap-wizard-create/dap-wizard-create.page.vue';
import DapWizardMethodologyComposedPage from '@/modules/dap/pages/dap-wizard-methodology-composed/dap-wizard-methodology-composed.page.vue';
import DapWizardMethodologySimplePage from '@/modules/dap/pages/dap-wizard-methodology-simple/dap-wizard-methodology-simple.page.vue';
import DapWizardNewPage from '@/modules/dap/pages/dap-wizard-new/dap-wizard-new.page.vue';
import DapWizardStoresPage from '@/modules/dap/pages/dap-wizard-stores/dap-wizard-stores.page.vue';

import DapSubmittedProjectsRetailPage from '@/modules/dap/pages/dap-submitted-projects-retail/dap-submitted-projects-retail.page.vue';

export const DAP_ROUTES = Object.freeze({
  PROJECT_EMPTY: 'DAP_PROJECT_EMPTY_PAGE',
  PROJECT: 'DAP_PROJECT_PAGE',
  PROJECTS: 'DAP_PROJECTS_PAGE',
  SUBMITTED_PROJECT: 'DAP_SUBMITTED_PROJECT_PAGE',
  SUBMITTED_PROJECT_RETAIL: 'DAP_SUBMITTED_PROJECT_RETAIL_PAGE',
  SUBMITTED_PROJECTS: 'DAP_SUBMITTED_PROJECTS_PAGE',
  SUBMITTED_PROJECTS_RETAIL: 'DAP_SUBMITTED_PROJECTS_RETAIL_PAGE',
  WIZARD_NEW: 'DAP_WIZARD_NEW_PAGE',
  WIZARD_CREATE: 'DAP_WIZARD_CREATE_PAGE',
  WIZARD_EDIT: 'DAP_WIZARD_EDIT_PAGE',
  WIZARD_STORES: 'DAP_WIZARD_STORES_PAGE',
  WIZARD_CONFIGURATION: 'DAP_WIZARD_CONFIGURATION_PAGE',
  WIZARD_CONFIGURATION_EDIT: 'DAP_WIZARD_CONFIGURATION_EDIT_PAGE',
  WIZARD_METHODOLOGY_SIMPLE: 'DAP_WIZARD_METHODOLOGY_SIMPLE_PAGE',
  WIZARD_METHODOLOGY_COMPOSED: 'DAP_WIZARD_METHODOLOGY_COMPOSED_PAGE'
});

const basePath = '/dap';

export const dapRoutes = [
  {
    path: `${basePath}/submitted/retailSales`,
    component: DapSubmittedProjectsRetailPage,
    name: DAP_ROUTES.SUBMITTED_PROJECTS_RETAIL
  },
  {
    path: `${basePath}/submitted/directSales`,
    component: DapSubmittedProjectsPage,
    name: DAP_ROUTES.SUBMITTED_PROJECTS
  },
  {
    path: `${basePath}/submitted/:projectId/store/:storeId`,
    component: DapSubmittedProjectPage,
    name: DAP_ROUTES.SUBMITTED_PROJECT,
    props: (route: Route) => ({
      projectId: Number(route.params.projectId),
      storeId: Number(route.params.storeId)
    })
  },
  {
    path: `${basePath}/submitted/retailSales/:projectId/store/:storeId`,
    component: DapSubmittedProjectRetailPage,
    name: DAP_ROUTES.SUBMITTED_PROJECT_RETAIL,
    props: (route: Route) => ({
      projectId: Number(route.params.projectId),
      storeId: Number(route.params.storeId)
    })
  },
  {
    path: '/neodash/dap',
    component: DapProjectsPage,
    name: DAP_ROUTES.PROJECTS,
    props: (route: Route) => ({
      projectId: Number(route.params.projectId),
      reloadProjects: Boolean(route.params.reloadProjects)
    }),
    children: [
      {
        path: ':projectId',
        component: DapProjectPage,
        name: DAP_ROUTES.PROJECT,
        props: (route: Route) => ({ projectId: Number(route.params.projectId) })
      },
      {
        path: '',
        component: DapProjectEmptyPage,
        name: DAP_ROUTES.PROJECT_EMPTY
      }
    ]
  },
  {
    path: `${basePath}/wizard/project`,
    component: DapWizardNewPage,
    name: DAP_ROUTES.WIZARD_NEW
  },
  {
    path: `${basePath}/wizard/project/create`,
    component: DapWizardCreatePage,
    name: DAP_ROUTES.WIZARD_CREATE
  },
  {
    path: `${basePath}/wizard/project/edit/:projectId`,
    component: DapWizardCreatePage,
    name: DAP_ROUTES.WIZARD_EDIT,
    props: (route: Route) => ({
      projectId: Number(route.params.projectId)
    })
  },
  {
    path: `${basePath}/wizard/project/:projectId/stores`,
    component: DapWizardStoresPage,
    name: DAP_ROUTES.WIZARD_STORES,
    props: (route: Route) => ({
      projectId: Number(route.params.projectId),
      wizardStep: Number(route.query.wizardStep)
    })
  },
  {
    path: `${basePath}/wizard/project/:projectId/methodology/:dapId/simple`,
    component: DapWizardMethodologySimplePage,
    name: DAP_ROUTES.WIZARD_METHODOLOGY_SIMPLE,
    props: (route: Route) => ({
      projectId: Number(route.params.projectId),
      dapId: Number(route.params.dapId),
      wizardStep: Number(route.query.wizardStep)
    })
  },
  {
    path: `${basePath}/wizard/project/:projectId/methodology/:dapId/composed`,
    component: DapWizardMethodologyComposedPage,
    name: DAP_ROUTES.WIZARD_METHODOLOGY_COMPOSED,
    props: (route: Route) => ({
      projectId: Number(route.params.projectId),
      dapId: Number(route.params.dapId),
      wizardStep: Number(route.query.wizardStep)
    })
  }
];
